enum CanPlayStatus {
  Disabled = 0,
  Active = 1,
  TimeOut = 2,
  SelfExcluded = 3,
  Quarantined = 4,
  DisabledPermanently = 5,
  RegulatoryExcluded = 7,
}
export default CanPlayStatus;
